import { render, staticRenderFns } from "./CeeYuuFooter2.vue?vue&type=template&id=6ca2028e&scoped=true"
import script from "./CeeYuuFooter2.vue?vue&type=script&lang=js"
export * from "./CeeYuuFooter2.vue?vue&type=script&lang=js"
import style0 from "./CeeYuuFooter2.vue?vue&type=style&index=0&id=6ca2028e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2028e",
  null
  
)

export default component.exports